import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar, Footer, Demo } from './components';
import MaintenanceMode from './components/NoAPI';
import routeConfig from './routes';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [apiUnavailable, setApiUnavailable] = useState(false);
  const API = process.env.REACT_APP_API;

  // ----------------------------
  // API health check
  // ----------------------------
  useEffect(() => {
    axios.get(`${API}/health`, { timeout: 7000 })
      .then(res => {
        console.log(res);
        const data = res.data;

        const isRailwayErrorBody =
          data?.status === "error" ||
          data?.status === "404" ||
          data?.message === "Application failed to respond" ||
          data?.message === "Application not found";

        const isRailwayProxyError =
          res?.status === 502;

        setApiUnavailable(isRailwayErrorBody || isRailwayProxyError);
      })
      .catch(err => {
        const isRealDown =
          err?.code === "ECONNABORTED" ||
          err?.code === "ERR_BAD_RESPONSE" ||
          err?.response?.status === 502 ||
          err?.response?.message === "Application not found";

        setApiUnavailable(isRealDown);
      });
  }, [API]);

  // ----------------------------
  // Auth, referral, online/offline checks
  // ----------------------------
  useEffect(() => {
    // Referral
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      axios.get(`${API}/ref/${ref}`);
      console.log(`${ref} referral`);
    }

    // Auth token
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('token='))
      ?.split('=')[1];

    setIsAuthenticated(true);
    if (token) {
      setIsAuthenticated(true);
    }

    setAuthChecked(true);

    // Online/offline
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [API]);

  // Internet toast
  useEffect(() => {
    if (!isOnline) {
      toast.error('No Internet connection');
    }
  }, [isOnline]);

  // Wait until auth check finished
  if (!authChecked) {
    return (
      <div className="h-screen flex items-center justify-center text-white bg-gray-900">
        <p>Checking Page...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App relative">
        <Navbar isAuthenticated={isAuthenticated} />

        <div className="container mx-auto">
          <Demo />
          <Routes>
            {routeConfig(isAuthenticated).map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </div>

        <Footer />
        <Toaster />

        {apiUnavailable && (
          <div className="absolute inset-0 z-50">
            <MaintenanceMode />
          </div>
        )}
      </div>
    </Router>
  );
};

export default App;
